(function () {
  const wrap = document.getElementById('gift-offer');
  if (!wrap) return;

  const THRESHOLD = Number(wrap.dataset.threshold || 99900); // 999 kr i öre
  const giftVariantIds = (wrap.dataset.giftVariantIds || '')
    .split(',')
    .map((x) => x.trim())
    .filter(Boolean);

  // ---- Helpers ----
  async function getCart() {
    return fetch('/cart.js').then((r) => r.json());
  }

  function getGiftQty(cart) {
    if (!giftVariantIds.length) return 0;
    return cart.items.reduce((sum, i) => {
      return sum + (giftVariantIds.includes(String(i.variant_id)) ? i.quantity : 0);
    }, 0);
  }

  function hasAnyGift(cart) {
    return getGiftQty(cart) > 0;
  }

  async function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    }).then((r) => r.json());
  }

  // Re-rendera sections via Shopify Sections API
  async function rerenderSections() {
    const toRender = (wrap.dataset.sectionsToRender || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);

    if (!toRender.length) {
      location.reload();
      return;
    }

    const url = new URL(window.location.origin + '/cart');
    url.searchParams.set('sections', toRender.join(','));

    const res = await fetch(url.toString());
    const contentType = res.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
      const data = await res.json();
      toRender.forEach((key) => {
        const html = data[key];
        const dst = document.getElementById(key);
        if (html && dst) dst.innerHTML = html;
      });
    } else {
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      toRender.forEach((id) => {
        const src = doc.getElementById(id);
        const dst = document.getElementById(id);
        if (src && dst) dst.innerHTML = src.innerHTML;
      });
    }

    // Efter DOM-uppdatering: uppdatera knapptexter
    updateGiftButtonsState();
  }

  // Sätt knapptexter beroende på om gåva finns i varukorgen
  async function updateGiftButtonsState() {
    const cart = await getCart();
    const anyGift = hasAnyGift(cart);

    document.querySelectorAll('.gift-offer__add').forEach((btn) => {
      btn.disabled = false; // aldrig låst
      btn.textContent = anyGift ? 'Lägg till en till' : 'Lägg till som gåva';
    });
  }
// Klick på “Visa fler parfymer” / “Visa färre parfymer”
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.gift-offer__toggle');
  if (!toggle) return;

  const giftOffer = toggle.closest('#gift-offer');
  if (!giftOffer) return;

  const expanded = giftOffer.classList.toggle('is-expanded');

  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  toggle.textContent = expanded ? 'Visa färre parfymer' : 'Visa fler parfymer';
});
  // Klick på “Lägg till som gåva” / “Lägg till en till”
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.gift-offer__add');
    if (!btn) return;

    btn.disabled = true;
    btn.textContent = 'Lägger till...';

    const cart = await getCart();
    const subtotal = cart.items_subtotal_price;

    // Om under tröskeln: tillåt inte att lägga till via knappen (du kan ändra detta om du vill)
    if (subtotal < THRESHOLD) {
      btn.disabled = false;
      // Visa tydligt varför det inte går just nu
      btn.textContent = 'Handla mer för att låsa upp';
      setTimeout(updateGiftButtonsState, 1200);
      return;
    }

    await addVariant(btn.dataset.variantId);
    await rerenderSections();
  });

  // Håll widgeten i synk när kund ändrar varukorgen (+/–, remove, manuell input)
  const changeSelectors = [
    '.quantity__button',
    '.quantity__input',
    '.cart-remove-button',
    '[name="updates[]"]',
  ];

  document.addEventListener('click', (e) => {
    if (changeSelectors.some((sel) => e.target.closest(sel))) {
      setTimeout(syncAfterCartChange, 700);
    }
  });
  document.addEventListener('change', (e) => {
    if (changeSelectors.some((sel) => e.target.closest(sel))) {
      setTimeout(syncAfterCartChange, 700);
    }
  });

  async function syncAfterCartChange() {
    // Vi tar inte bort något automatiskt – uppdaterar bara UI så text/progress blir rätt.
    await rerenderSections();
  }

  // Init
  updateGiftButtonsState();
})();
